import { render } from "./myteamadd.vue?vue&type=template&id=6a9c02ee&scoped=true"
import script from "./myteamadd.vue?vue&type=script&lang=js"
export * from "./myteamadd.vue?vue&type=script&lang=js"

import "./myteamadd.vue?vue&type=style&index=0&id=6a9c02ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9c02ee"]])

export default __exports__